import { keyframes } from '@mui/material/styles'

// A slow blink, used by the small "this is live" dots.
export const beat = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.25; }
`

// A left-to-right sweep, used by the thin bar above the table.
export const fill = keyframes`
  from { transform: scaleX(0); }
  to { transform: scaleX(1); }
`

// Some people ask their operating system to reduce animation. Every animated
// style in this app switches itself off inside this media query.
export const NO_MOTION = '@media (prefers-reduced-motion: reduce)'
